<template>
  <div>
    <div style="margin: 0 auto;width: 50%">
      <h2 v-if="!suppliesId" style="text-align: center;margin-top: 20px">新增物资</h2>
      <h2 v-if="suppliesId" style="text-align: center;margin-top: 20px">修改物资</h2>
      <Form :model="suppliesForm" :label-width="120" style="margin-top: 30px" :rules="suppliesRules" ref="suppliesForm">
        <FormItem label="物资名称" prop="name">
          <Input v-model="suppliesForm.name" placeholder="请输入物资名称"></Input>
        </FormItem>
        <FormItem label="单位" prop="unit">
          <Input v-model="suppliesForm.unit" placeholder="请输入单位"></Input>
        </FormItem>
        <FormItem label="物资数量" prop="goodsNumber">
          <Input v-model="suppliesForm.goodsNumber" placeholder="请输入物资数量"></Input>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input v-model="suppliesForm.remark" placeholder="请输入备注"></Input>
        </FormItem>
        <FormItem label="生效日期" prop="effectiveDate">
          <DatePicker v-model="suppliesForm.effectiveDate" type="date" placeholder="选择日期"></DatePicker>
        </FormItem>
<!--        <FormItem label="适用事件类型" prop="applicableEventTypes" :label-width="120">-->
<!--          <Select v-model="suppliesForm.applicableEventTypes" placeholder="请选择适用事件类型">-->
<!--            <Option v-for="item in applicableEventTypesList" :key="item.id" :value="item.id">{{ item.name }}</Option>-->
<!--          </Select>-->
<!--        </FormItem>-->
      </Form>
      <div style="text-align: center;margin-top: 30px">
        <Button v-if="!suppliesId" type="primary" @click="submitNewSupplies()" :loading="createLoading">新增</Button>
        <Button v-else type="primary" style="margin-left: 20px" @click="submitEditSupplies()" :loading="editLoading">
          修改
        </Button>
        <Button type="error" style="margin-left: 20px" @click="resetForm()">重置</Button>
        <Button @click="goBack" style="margin-left: 20px">返回</Button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      applicableEventTypesList: [],
      suppliesId: null,
      createLoading: false,
      editLoading: false,
      suppliesForm: {
        name: '',
        unit: '',
        goodsNumber: '',
        remark: '',
        effectiveDate: '',
      },
      suppliesRules: {
        name: [
          {required: true, message: '请输入物资名称', trigger: 'blur'}
        ],
        unit: [
          {required: true, message: '请输入单位', trigger: 'blur'}
        ],
        goodsNumber: [
          {required: true, message: '请输入物资数量', trigger: 'blur'}
        ],
        remark: [
          {required: true, message: '请输入备注', trigger: 'blur'}
        ],
        effectiveDate: [
          {required: true, message: '请选择生效日期', trigger: 'blur', type: 'date'}
        ],
      }
    }
  },
  mounted() {
    this.suppliesId = this.$route.query.id
    if (this.suppliesId) {
      this.getSuppliesById()
    }
    this.getApplicableEventTypesList()
  },
  methods: {
    getApplicableEventTypesList() {
      this.$http.get('/api/event/getAll').then(res => {
        if (res.status === 200) {
          this.applicableEventTypesList = res.data.data
        }
      })
    },
    submitNewSupplies() {
      this.$refs.suppliesForm.validate(valid => {
        if (valid) {
          this.createLoading = true
          let requestData = {
            ...this.suppliesForm,
            goodsNumber: this.suppliesForm.goodsNumber.toString()
          }
          this.$http.post('/api/goodsConfig/goodsConfigs', requestData).then(res => {
            if (res.status === 201) {
              this.$Message.success('新增物资成功')
              this.createLoading = false
              this.$router.push({name: 'supplies'})
            } else {
              this.$Message.error('新增物资失败')
            }
          }).catch(() => {
            this.$Message.error('新增物资失败')
          })
        }
      })
    },
    getSuppliesById() {
      this.$http.get(`/api/goodsConfig/goodsConfigs/${this.suppliesId}`).then(res => {
        if (res.status === 200) {
          this.suppliesForm = res.data
          this.suppliesForm.applicableEventTypes = res.data.applicableEventTypes.toString()
          this.suppliesForm.goodsNumber = res.data.goodsNumber.toString()
        }
      })
    },
    submitEditSupplies() {
      this.$refs.suppliesForm.validate(valid => {
        if (valid) {
          this.editLoading = true
          let requestData = {
            ...this.suppliesForm,
            id: this.suppliesId,
            goodsNumber: this.suppliesForm.goodsNumber
          }
          this.$http.put('/api/goodsConfig/goodsConfigs', requestData).then(res => {
            if (res.status === 200) {
              this.$Message.success('修改物资成功')
              this.editLoading = false
              this.$router.push({name: 'supplies'})
            } else {
              this.$Message.error('修改物资失败')
            }
          }).catch(() => {
            this.$Message.error('修改物资失败')
          })
        }
      })
    },
    resetForm() {
      this.$refs.suppliesForm.resetFields()
    },
    goBack() {
      this.$router.push({name: 'supplies'})
    }
  }
}
</script>
